if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (item.target.classList.contains("cart-recap__price-line-price")) {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('cart:rerendered', ()=>{
       BSS_B2B.observer.cartSubject.listenCartCheckout();
    })
  }, 500);
}
